import { useQuery } from 'react-query'
import { QueryOptions } from '../../types'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services/appointments'

type UseAppointmentResourcesQuery = {
  gid?: string
}

const hookName = 'useAppointmentResources'
const log = logFactory(hookName)

const useAppointmentResources = (query: UseAppointmentResourcesQuery, options: QueryOptions = { enabled: true }) => {
  const { getResources, isReady } = useAppointmentsService()

  const doQuery = async () => {
    log(`🙉 Getting resources...`, query)

    const data = await getResources({ gid: query.gid })

    log(`🙉 Found resources`, data)

    return data
  }

  const isQueryEnabled = isReady && options.enabled

  return useQuery([hookName, query], doQuery, { ...options, enabled: isQueryEnabled })
}

export { useAppointmentResources }
